import React, { useState, useEffect } from "react";
import axios from "utils/axios";
import Ad from "components/Ad";

const TopAds = () => {
  const [ads, setAds] = useState<Array<any>>([]);

  useEffect(() => {
    const getAd = async () => {
      const result = await axios.get("/api/ad/topAds");
      setAds(result.data);
    };
    getAd();
  }, []);

  return (
    <div className="flex xl:flex-col gap-[32px] lg:mx-auto md:mx-auto sm:mx-auto sm:flex-col flex-wrap">
      {ads.map((ad, index) => (
        <Ad
          id={ad.id}
          title={ad.title}
          websiteLink={ad.websiteLink}
          description={ad.description}
          file={ad.image}
          resourceName={ad.resourceName}
          key={index}
        />
      ))}
    </div>
  );
};
export default TopAds;
